var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "SectionContainerPage",
    [
      _c("SectionClientList", {
        attrs: {
          xs12: "",
          clientList: _vm.clientList,
          toolbarActions: [],
          isLoading: _vm.isLoading,
          shouldShowSearch: true,
        },
        on: {
          onAddNewClientClicked: function ($event) {
            _vm.showDialogFormClientAdd = true
          },
          onEditClientClicked: (val) => [
            (_vm.clientToEdit = val.clientToEdit),
            (_vm.showDialogFormClientEdit = true),
          ],
        },
      }),
      _vm._v(" "),
      _c("DialogFormClientAdd", {
        attrs: {
          showDialog: _vm.showDialogFormClientAdd,
          isLoading: _vm.isLoading,
        },
        on: {
          onCancelClicked: function ($event) {
            _vm.showDialogFormClientAdd = false
          },
          onSubmitClicked: (val) => [_vm.onDialogFormClientAddSubmit(val)],
        },
      }),
      _vm._v(" "),
      _c("DialogFormClientEdit", {
        attrs: {
          showDialog: _vm.showDialogFormClientEdit,
          clientToEdit: _vm.clientToEdit,
          isLoading: _vm.isLoading,
        },
        on: {
          onCancelClicked: function ($event) {
            _vm.showDialogFormClientEdit = false
          },
          onSubmitClicked: (val) => [_vm.onDialogFormClientEditSubmit(val)],
        },
      }),
      _vm._v(" "),
      _c("DialogFormConfirmation", {
        attrs: {
          showDialog: _vm.confirmationDialogShow,
          title: _vm.confirmationDialogTitle,
          message: _vm.confirmationDialogMessage,
          submitButtonText: _vm.confirmationDialogSubmitButtonText,
          submitButtonIcon: _vm.confirmationDialogSubmitButtonIcon,
          submitButtonColor: _vm.confirmationDialogSubmitButtonColor,
          cancelButtonText: _vm.confirmationDialogCancelButtonText,
          showCancelButton: _vm.confirmationDialogShowCancelButton,
          isLoading: _vm.isLoading,
        },
        on: {
          onSubmitClicked: _vm.onConfirmationDialogSubmitClicked,
          onCancelClicked: _vm.onConfirmationDialogCancelClicked,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }